import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { State, Action, Getter, Mutation } from 'vuex-class';
import HttpRequest from '@/../bower_components/teknisavuecomponents/assets/utils/HttpRequest';
import DateUtil from '@/../bower_components/teknisavuecomponents/assets/utils/DateUtil';
import Util from '@/../bower_components/teknisavuecomponents/assets/utils/Util';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import DialogUtils from '@/../bower_components/teknisavuecomponents/assets/utils/DialogUtils';

import TkSelect from '@/../bower_components/teknisavuecomponents/components/fields/TkSelect.vue';
import EditableTable from '@/../bower_components/teknisavuecomponents/components/grids/EditableTable.vue';
import TkNavigableForm from '@/../bower_components/teknisavuecomponents/components/TkNavigableForm.vue';
import TkToolbar from '@/../bower_components/teknisavuecomponents/components/grids/TkToolbar.vue';
import { ControleAcessoWrapper } from '@/assets/ts/controller/ControleAcessoController';

@Component({
  name: 'LancamentoFolha',
  components: {
    TkNavigableForm,
    EditableTable,
    TkSelect,
    TkToolbar,
  },
})
class LancamentoFolha extends Vue {
  //#region [DATA]
  private viewName = 'lancamentoFolha';
  private viewTitle = 'Lançamento de Folha';

  private currentLote = null;
  private lancamentos = [];

  private triggerUpdateGrid = 0;
  private triggerAddLote = 0;
  private triggerCancelLote = 0;
  private triggerReloadLotes = 0;
  private triggerReloadLancamentos = 0;
  private triggerReloadMovimentos = 0;

  private index = 0;
  private gridPage = 0;

  private selectedVinculos = [];
  private selectedEventos = [];

  private lancamentosVinculos = [];
  private lancamentosEventos = [];

  private loteFormIsLoading = false;

  private lancamentosGridCancelReload = false;
  private lancamentosGridIsLoading = false;

  private loteBackup = null;

  private formDefaultRow = {
    IDSTATUSLOTELANC: 'DIGITACAO',
    DTLOTELANCEVENTO: DateUtil.getCurrentDate(),
    DTCOMPETLOTEEVE: DateUtil.getDateCompetenc(),
    NRTIPOMOVIMENT: '1',
    IDATIVO: 'S',
  };

  private gridColumns = [
    {
      value: 'NMVINCULOM',
      text: 'Vínculo',
      type: 'text',
      readonly: true,
    },
    {
      value: 'NREVENTOM',
      text: 'Nr. Evento',
      type: 'text',
      readonly: true,
      width: '150px',
    },
    {
      value: 'NMEVENTOH',
      text: 'Evento',
      type: 'text',
      readonly: true,
      width: '400px',
    },
    {
      value: 'VRREFFOLHALOTE',
      text: 'Referência',
      type: 'text',
      align: 'right',
      textAlign: 'right',
      width: '150px',
    },
    {
      value: 'VREVENTOLOTE',
      text: 'Valor',
      type: 'text',
      align: 'right',
      textAlign: 'right',
      width: '150px'
    },
  ];
  //#endregion

  //#region [STORE]
  @Getter('estruturaGerencialAtual')
  private estruturaGerencialAtual: any;

  @Getter('periodoDemonstrativoAtual')
  private periodoDemonstrativoAtual: any;

  @Getter('user')
  private user: any;

  @Mutation('changeCurrentView')
  private changeCurrentView: any;
  //#endregion

  //#region [COMPUTED]
  private get lotesFilters(): any {
    if (!this.user || !this.periodoDemonstrativoAtual) {
      return null;
    }

    const filters = {
      CDOPERADOR: this.user.cdoperador,
      NRPERIODOAPURACAO: this.periodoDemonstrativoAtual.NRPERIODOAPURACAO,
      NRORG: this.user.nrorg,
    };

    return filters;
  }

  private get lancamentosFilters(): any {
    if (!this.currentLote || !this.currentLote.NRLOTELANCEVENTO ||
        !this.periodoDemonstrativoAtual || !this.estruturaGerencialAtual) {

      return null;
    }

    const filters = {
      NRLOTELANCEVENTO: this.currentLote.NRLOTELANCEVENTO,
      NRPERIODOAPURACAO: this.periodoDemonstrativoAtual.NRPERIODOAPURACAO,
      NRESTRUTURAM: this.estruturaGerencialAtual.NRESTRUTURAM,
      NRORG: this.user.nrorg,
    };

    return filters;
  }

  private get formMode(): string {
    if (this.currentLote) {
      const mode = this.currentLote.IDSTATUSLOTELANC === 'DIGITACAO' ?
      'edit' :
      'view';

      return mode;
    } else {
      return 'view';
    }
  }

  private get movimentosFilters(): any {
    if (!this.user) {
      return null;
    }

    const filters = {
      NRORG: this.user.nrorg,
    };

    return filters;
  }

  private get filteredLancamentos(): any[] {
    const vinculos = this.selectedVinculos;
    const eventos = this.selectedEventos;

    const filteredLancs = this.lancamentos.filter((lancamento: any) => {
      const match = this.gridCustomFilter(lancamento, vinculos, eventos);
      return match;
    });

    return filteredLancs;
  }

  private get gridIsDisabled(): boolean {
    if (!this.currentLote) {
      return true;
    }

    const loteIsSelected = !Util.isEmptyOrBlank(this.currentLote.NRLOTELANCEVENTO);

    const disabled = !loteIsSelected ||
      this.loteFormIsLoading ||
      this.lancamentosGridIsLoading;

    return disabled;
  }

  private get formToolbarActions(): any[] {
    const isNewLote = this.currentLote ?
      this.currentLote.__is_new === true :
      false;

    const actions = [
      {
        name: 'reload',
        label: 'Atualizar',
        icon: 'mdi-refresh',
        onClick: this.reloadLotesForm,
        disabled: isNewLote,
      },
      {
        name: 'add',
        label: 'Adicionar',
        icon: 'mdi-plus-circle',
        onClick: ControleAcessoWrapper.criar(this.formAddNewRow),
        disabled: isNewLote,
      },
      {
        name: 'saveLote',
        label: 'Salvar Lote',
        icon: 'mdi-content-save',
        onClick: ControleAcessoWrapper.criar(this.save),
        disabled: !this.digitacao,
      },
      {
        name: 'delete',
        label: 'Remover',
        icon: 'mdi-delete',
        onClick: ControleAcessoWrapper.deletar(this.deleteLote),
        disabled: !isNewLote && !this.digitacao
      },
      {
        name: 'confirm',
        label: 'Confirmar Lote',
        icon: 'mdi-check-bold',
        inMenu: true,
        onClick: ControleAcessoWrapper.criar(this.confirmLote),
        disabled: !this.digitacao || isNewLote || !this.currentLote,
      },
    ];

    return actions;
  }

  private get gridToolbarActions() {
    const actions = [
      {
        name: 'reload',
        label: 'Atualizar',
        icon: 'mdi-refresh',
        onClick: this.reloadLancamentosGrid,
      },
      {
        name: 'saveLanc',
        label: 'Salvar Lançamentos',
        icon: 'mdi-content-save',
        onClick: ControleAcessoWrapper.atualizar(this.editLancamentos),
        disabled: !this.digitacao,
      }
    ];

    return actions;
  }

  public get digitacao(): boolean {
    const emDigitacao = this.currentLote ?
      this.currentLote.IDSTATUSLOTELANC === 'DIGITACAO' :
      false;

    return emDigitacao;
  }

  private get formFields(): any[] {
    const fields = [
      {
        name: 'DSLOTELANCEVENTO',
        label: 'Descrição',
        size: 6,
        type: 'text',
        required: true,
      },
      {
        name: 'DTLOTELANCEVENTO',
        label: 'Data de Lançamento',
        size: 3,
        type: 'date',
        readonly: true,
      },
      {
        name: 'DTCOMPETLOTEEVE',
        label: 'Data de Competência',
        size: 3,
        type: 'date',
        required: true,
        month: true,
      },
      {
        name: 'DTOCORRENCIA',
        label: 'Data de Ocorrência',
        size: 4,
        type: 'date',
      },
      {
        name: 'NRTIPOMOVIMENT',
        label: 'Movimento',
        descriptionField: 'NMTIPOMOVIMENT',
        valueField: 'NRTIPOMOVIMENT',
        size: 4,
        type: 'select',
        route: 'getTiposMovimento',
        filters: this.movimentosFilters,
        required: true,
        triggerReload: this.triggerReloadMovimentos,
      },
      {
        name: 'IDSTATUSLOTELANC',
        label: 'Status',
        size: 4,
        type: 'select',
        readonly: true,
        items: [
          {
            value: 'APROVADO',
            text: 'Aprovado'
          },
          {
            value: 'PENDENTE',
            text: 'Pendente'
          },
          {
            value: 'REPROVADO',
            text: 'Reprovado'
          },
          {
            value: 'DIGITACAO',
            text: 'Digitação'
          },
        ],
      },
    ];

    return fields;
  };

  public get gridMode(): string {
    const mode = this.digitacao ?
      'edit' :
      'view';

    return mode;
  }

  public get gridItemsPerPage(): number {
    const items = this.digitacao ?
      10 :
      15;

    return items;
  }
  //#endregion

  //#region [LIFECYCLE]
  private created() {
    this.changeCurrentView(this.viewTitle);
    (window as any).lancamentoFolha = this;
  }

  private mounted() {
    this.reloadLotesForm();
    this.reloadMovimentos();
  }
  //#endregion

  // #region [WATCHERS]
  @Watch('estruturaGerencialAtual')
  private estruturaOnChange() {
    this.reloadLancamentosGrid();
  }

  @Watch('periodoDemonstrativoAtual')
  private periodoOnChange() {
    this.reloadLotesForm();
  }

  @Watch('user')
  private userOnChange() {
    this.reloadMovimentos();
  }
  // #endregion

  //#region [METHODS]
  private onFormIndexChange(index: number, selectedLote: any) {
    this.currentLote = selectedLote;
    this.loteBackup = Util.deepCopy(this.currentLote);

    if (!this.currentLote || !this.currentLote.NRLOTELANCEVENTO) {
      this.lancamentos = [];
      this.lancamentosGridCancelReload = true;
    } else {
      this.reloadLancamentosGrid();
    }
  }

  private formAfterReload(formRows: any[]) {
    this.currentLote = formRows[0] || null;

    if (this.currentLote) {
      this.loteBackup = Util.deepCopy(this.currentLote);
    }

    this.reloadLancamentosGrid();
  }

  private reloadLotesForm() {
    if (this.lotesFilters !== null) {
      this.triggerReloadLotes++;
    }
  }

  private reloadLancamentosGrid() {
    if (this.lancamentosFilters !== null) {
      this.triggerReloadLancamentos++;
    } else {
      this.lancamentos = [];
    }
  }

  private reloadMovimentos() {
    if (this.movimentosFilters !== null) {
      this.triggerReloadMovimentos++;
    }
  }

  private gridAfterReload(gridRows) {
    this.gridPage = 1;

    gridRows.forEach((row: any) => {
      this.formatReferenciaAndValor(row);
    });

    this.lancamentos = gridRows;

    this.updateLancamentosEventos();
    this.updateLancamentosVinculos();
  }

  private formOnInput(row: any, rows: any[]) {
    this.currentLote = row;
  }

  private async save() {
    if (!this.currentLote.__is_valid) {
      const message = 'Favor preencher todos campos obrigatórios.';

      SnackbarUtils.showMessage(message, 'alert');
      return;
    }

    if (this.currentLote.__is_new) {
      this.saveNewLote();
    } else {
      this.editLote();
    }
  }

  private async saveNewLote() {
    const route = 'insertLoteLancamento';

    const row = {
      ...this.currentLote,
      CDOPERADOR: this.user.cdoperador,
      NRORG: this.user.nrorg,
    };

    const params = {
      requestType: 'Row',
      row,
    };

    this.loteFormIsLoading = true;

    try {
      const response = await HttpRequest.post(route, params, false);
      const success = response.data.dataset.data.success;

      this.reloadLotesForm();
      SnackbarUtils.showMessage('Lote salvo com sucesso.');
    } catch (err) {
      SnackbarUtils.showMessage('Não foi possível salvar o lote.', 'error', 5000);
      throw err;
    } finally {
      this.loteFormIsLoading = false;
    }
  }

  private async editLote() {
    const route = 'editLoteLancamento';

    const row = {
      ...this.currentLote,
      CDOPERADOR: this.user.cdoperador,
    };

    const params = {
      requestType: 'Row',
      row,
    };

    this.loteFormIsLoading = true;

    try {
      const response = await HttpRequest.post(route, params, false);
      const success = response.data.dataset.data.success;

      if (!success) {
        throw new Error(response.data);
      }

      SnackbarUtils.showMessage('Lote editado com sucesso.')
      this.reloadLotesForm();
    } catch (err) {
      SnackbarUtils.showMessage('Não foi possível editar o lote.', 'error', 5000);
      throw err;
    } finally {
      this.loteFormIsLoading = false;
    }
  }

  private async editLancamentos() {
    const changedRows = this.lancamentos.filter((row) => row.__changed);

    if (changedRows.length === 0) {
      const message = 'Nenhum lançamento foi editado.';
      SnackbarUtils.showMessage(message, 'alert');

      return;
    }

    const lancamentosCopy = Util.deepCopy(changedRows);

    lancamentosCopy.forEach((lancamento: any) => {
      if (lancamento.VREVENTOLOTE) {
        lancamento.VREVENTOLOTE = parseFloat(
          lancamento.VREVENTOLOTE.replace(',', '.'));
      }

      if (lancamento.VRREFFOLHALOTE) {
        lancamento.VRREFFOLHALOTE = parseFloat(
          lancamento.VRREFFOLHALOTE.replace(',', '.'));
      }
    });

    const route = 'editLancamentos';

    const row = {
      CDOPERADOR: this.user.cdoperador,
      lancamentos: lancamentosCopy,
      NRORG: this.user.nrorg,
    };

    const params = {
      requestType: 'Row',
      row,
    };

    this.lancamentosGridIsLoading = true;

    try {
      const response = await HttpRequest.post(route, params, false);
      const success = response.data.dataset.data.success;

      SnackbarUtils.showMessage('Lançamentos salvos com sucesso.');
      this.reloadLancamentosGrid();
    } catch (err) {
      SnackbarUtils.showMessage('Não foi possível salvar os lançamentos.', 'error', 5000);
      throw err;
    } finally {
      this.lancamentosGridIsLoading = false;
    }
  }

  private gridCustomFilter(lancamento: any, vinculos: any[], eventos: any[]): boolean {
    let inVinculos = false;
    let inEventos = false;

    const nrVinculo = parseInt(lancamento.NRVINCULOM, 10);
    const nrEvento = lancamento.NREVENTOM;

    if (vinculos.length === 0) {
      inVinculos = true;
    } else {
      inVinculos = vinculos.includes(nrVinculo);
    }

    if (eventos.length === 0) {
      inEventos = true;
    } else {
      inEventos = eventos.includes(nrEvento);
    }

    return inVinculos && inEventos;
  }

  private formAddNewRow() {
    this.triggerAddLote++;
  }

  private formatReferenciaAndValor(lancamento: any, useComma = true) {
    let valor: string = lancamento.VREVENTOLOTE || '';
    let referencia: string = lancamento.VRREFFOLHALOTE || '';

    valor = valor.replace(',', '.');
    referencia = referencia.replace(',', '.');

    if (referencia) {
      // Formats "referencia" in order to make it have 4 decimal places
      // 100,222287 --> 100,2223
      referencia = parseFloat(referencia).toFixed(4);
    }

    if (valor) {
      // Formats "valor" in order to make it have 2 decimal places
      // 100,116287 --> 100,12
      valor = parseFloat(valor).toFixed(2);
    }

    if (useComma) {
      valor = valor.replace('.', ',');
      referencia = referencia.replace('.', ',');
    }

    lancamento.VREVENTOLOTE = valor || null;
    lancamento.VRREFFOLHALOTE = referencia || null;
  }

  private onLancamentosChange(newLancamentos: any[]) {
    this.lancamentos = newLancamentos;
  }

  private onLancamentoFieldBlur(row: any, column: any) {
    const lancamento = this.lancamentos.find((lanc: any) => {
      return lanc.__id === row.__id;
    });

    if (lancamento) {
      this.formatReferenciaAndValor(lancamento);
    }
  }

  private updateLancamentosVinculos() {
    const vinculos = this.lancamentos.reduce((accumulator: any[], lanc: any) => {
      const includes = Util.arrayIncludes(accumulator, (vinculo: any) => {
        const isVinculo = vinculo.NRVINCULOM === lanc.NRVINCULOM;
        return isVinculo;
      });

      if (!includes) {
        const newVinculo = {
          NMVINCULOM: lanc.NMVINCULOM,
          NRVINCULOM: parseInt(lanc.NRVINCULOM, 10),
        };

        accumulator.push(newVinculo);
      }

      return accumulator;
    }, []);

    vinculos.sort((a, b) => {
      const nmVinculoA: string = a.NMVINCULOM ?
        a.NMVINCULOM.toUpperCase() :
        '';

      const nmVinculoB: string = b.NMVINCULOM ?
        b.NMVINCULOM.toUpperCase() :
        '';

      const comparison = nmVinculoA.localeCompare(nmVinculoB);

      return comparison;
    });

    this.lancamentosVinculos = vinculos;
  }

  /**
   * Retorna todos o nome de todos os vínculos que estão relacionados
   * a pelo menos um lançamento do lote.
   */
  private updateLancamentosEventos() {
    const eventos = this.lancamentos.reduce((accumulator: any[], lanc: any) => {
      const includes = Util.arrayIncludes(accumulator, (evento: any) => {
        const isSameEvento = evento.NREVENTOM === lanc.NREVENTOM;
        return isSameEvento;
      });

      if (!includes) {
        const newEvento = {
          NMEVENTOH: lanc.NMEVENTOH,
          NREVENTOM: lanc.NREVENTOM,
        };

        accumulator.push(newEvento);
      }

      return accumulator;
    }, []);

    eventos.sort((a, b) => {
      const nmEventoA: string = a.NMEVENTOH ?
        a.NMEVENTOH.toUpperCase() :
        '';

      const nmEventoB: string = b.NMEVENTOH ?
        b.NMEVENTOH.toUpperCase() :
        '';

      const comparison = nmEventoA.localeCompare(nmEventoB);

      return comparison;
    });

    this.lancamentosEventos = eventos;
  }

  private onFormLoadingChange(isLoading: boolean) {
    this.loteFormIsLoading = isLoading;
  }

  private async confirmLote() {
    const route = 'confirmLoteLancamento';

    const row = {
      NRLOTELANCEVENTO: this.currentLote.NRLOTELANCEVENTO,
      NRORG: this.user.nrorg,
    };

    const params = {
      requestType: 'Row',
      row,
    };

    this.loteFormIsLoading = true;

    try {
      const response = await HttpRequest.post(route, params, false);
      const success = response.data.dataset.data.success;

      if (success) {
        SnackbarUtils.showMessage('Lote confirmado com sucesso.');
      } else {
        throw new Error(response.data);
      }
    } catch (err) {
      SnackbarUtils.showMessage('Não foi possível confirmar o lote.', 'error', 5000);
      throw err;
    } finally {
      this.loteFormIsLoading = false;
      this.reloadLotesForm();
    }
  }

  private async deleteLote() {
    if (this.currentLote.__is_new) {
      this.triggerCancelLote++;
      return;
    }

    await DialogUtils.show('Remover Lote', 'Deseja realmente remover o lote?');

    const route = 'deleteLoteLancamento';

    const params = {
      requestType: 'Row',
      row: {
        NRORG: this.user.nrorg,
        NRLOTELANCEVENTO: this.currentLote.NRLOTELANCEVENTO,
      },
    };

    this.loteFormIsLoading = true;

    try {
      const response = await HttpRequest.post(route, params, false);
      const success = response.data.dataset.data.success;

      if (success) {
        SnackbarUtils.showMessage('Lote removido com sucesso.');
        this.reloadLotesForm();
      } else {
        throw new Error(response.data);
      }
    } catch (err) {
      SnackbarUtils.showMessage('Não foi possível remover o lote.', 'error', 5000);
      throw err;
    } finally {
      this.loteFormIsLoading = false;
    }

  }
  // #endregion
}

export default LancamentoFolha;